import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import { FormAuthoringBreadcrumbs } from "./components/FormAuthoringBreadcrumbs";

import { markdownify } from "../../utils/markdown";

import Review from "../Reviews/Review";

markdownify(document.getElementsByClassName("is-markdown"));

type BreadcrumbData = {
	formName: string;
	reviewId: string;
	reviewName: string;
	cycleName: string;
	canViewReviewCycles: boolean;
};

const readBreadcrumbData = (el: HTMLElement): BreadcrumbData => ({
	formName: el.dataset.formName ?? "",
	reviewId: el.dataset.reviewId ?? "",
	reviewName: el.dataset.reviewName ?? "",
	cycleName: el.dataset.cycleName ?? "",
	canViewReviewCycles: el.dataset.canViewReviewCycles === "true",
});

export const ViewReviewForm = () => {
	const [mount, setMount] = useState<HTMLElement | null>(null);

	useEffect(() => {
		const el = document.getElementById("form-authoring-breadcrumbs");
		setMount(el);
	}, []);

	return (
		<>
			<Review />
			{mount ? ReactDOM.createPortal(<FormAuthoringBreadcrumbs {...readBreadcrumbData(mount)} />, mount) : null}
		</>
	);
};
